import {Injectable} from '@angular/core';
import {RestClientService} from '../rest-client/rest-client.service';
import {Observable} from 'rxjs';
import {AuthenticationTokens, LoginModel} from '../model';

@Injectable({
  providedIn: 'root'
})
export class UserAuthenticationService {

  constructor(private restClient: RestClientService) {
  }

  loginWithCredentials(email: string, password: string): Observable<AuthenticationTokens> {
    return this.restClient.post<AuthenticationTokens>('/login', {
      username: email,
      password: password
    } as LoginModel);
  }

  loginWithMcardsTokenToken(token: string, application: Application): Observable<AuthenticationTokens> {
    return this.restClient.post<AuthenticationTokens>(`/mcards/authentication`, {token, application});
  }
}

export enum Application {
  LOYALTY = 'LOYALTY',
  FREE_MONEY = 'FREE_MONEY'
}
